<template>
    <div class="page-container">
        <div class="px-8 md:px-5 py-5 ">
            <h1 class="mb-6">
                Users
            </h1>
            <user-grid
                    title="Select a machine to log the Job against:"
            ></user-grid>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import UserGrid from './includes/UserGrid.vue';

    export default {
        components: {
            UserGrid
        },

        created: function () {
            this.getClient({ clientID: this.profile.client_id});
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            })
        }
    }
</script>
